import {APP_ACTION_TYPE, ENGAGEMENT_SOURCE, ENGAGEMENT_SOURCE_LOCATION, FeaturedItemStore, IAppActionExternalUrl, IAppActionFeaturedItem, IAppActionMenuItem, ISpecial, OrderStore} from '../store';
import {ItemService} from '.';
import type {IAddItemParams} from '../store/order/order.types';
import type {ILineItem} from '../store';

const RE_HTTP = /^https?:\/\//;


class Specials {
	async handleSpecialsAction(
		special: ISpecial,
		dialogComponentLocation: IAddItemParams['dialogComponentLocation'],
		dialogComponentConfirmation: IAddItemParams['dialogComponentConfirmation'],
		dialogComponentActiveTicket: IAddItemParams['dialogComponentActiveTicket'],
	) {
		if(special.appAction.type === APP_ACTION_TYPE.EXTERNAL_URL) {
			let url = (special.appAction as IAppActionExternalUrl).url;
			if(!RE_HTTP.test(url)) {
				url = 'https://' + url;
			}
			window.open(url, '_blank');
		} else if(special.appAction.type === APP_ACTION_TYPE.MENU_ITEM) {
			const itemFavorite = (special.appAction as IAppActionMenuItem).customerItemFavorite;
			await OrderStore.addLineItemWithUserPrompts({
				dialogComponentActiveTicket,
				dialogComponentConfirmation,
				dialogComponentLocation,
				itemDescriptor: {
					itemId: itemFavorite.itemId,
					itemHqId: itemFavorite.itemHqId,
					itemOptions: itemFavorite.options,
				},

				hookLocationSelected: (lineItem: ILineItem | null) => new Promise((resolve, reject) => {
					if(lineItem) {
						lineItem.engagementSource = ItemService.lineItemEngagementSourceFromSpecial(special, ENGAGEMENT_SOURCE.SPECIAL, ENGAGEMENT_SOURCE_LOCATION.SPECIAL);
						resolve(lineItem);
						return;
					}
					reject(new Error());
				}),
			});
		} else if(special.appAction.type === APP_ACTION_TYPE.FEATURED_ITEM) {
			await OrderStore.addLineItemWithUserPrompts({
				dialogComponentActiveTicket,
				dialogComponentConfirmation,
				dialogComponentLocation,
				itemDescriptor: null,

				/*
				 * We're not providing a usable itemDescriptor, above, and will instead have
				 * to wait until a location is selected to attempt a lookup.
				 */
				hookLocationSelected: (lineItem: ILineItem | null) => new Promise((resolve, reject) => {
					if(!lineItem) {
						const featuredItem = FeaturedItemStore.featuredItem((special.appAction as IAppActionFeaturedItem).featuredItemId);
						if(!featuredItem) {
							reject(new Error('Unable to locate featured item'));
						}

						lineItem = ItemService.lineItemGetById({
							itemId: featuredItem?.itemId ?? null,
							itemHqId: featuredItem?.itemHqId ?? null,
							itemOptions: featuredItem?.options ?? [],
						});
						if(lineItem) {
							lineItem.engagementSource = ItemService.lineItemEngagementSourceFromSpecial(special, ENGAGEMENT_SOURCE.FEATURED, ENGAGEMENT_SOURCE_LOCATION.SPECIAL);
							resolve(lineItem);
							return;
						}
						reject(new Error('Unable to locate item from featured item'));
					}

					// This seems like a state we'll never reach, given the conditions before calling hookLocationSelected.
					reject(new Error('Hook called with existing item'));
				}),
			});
		} else {
			// Nothing configured for special
		}
	}
}

export const SpecialsService = new Specials();
